import React, { Suspense } from "react";

import { Navigate, Outlet } from "react-router-dom";

import Loader from "react-loaders";
import Loading from "../common/Loading"

const ProtectedRoutes = ({ isLoggedIn }) => {
  return isLoggedIn ? (
    <Suspense
      fallback={
        <div
          className="loader-container"
          style={{ width: "75vw", height: "75vh" }}
        >
          <div className="loader-container-inner">
            <div className="text-center">
              <Loading />
            </div>
          </div>
        </div>
      }
    >
      <Outlet />
    </Suspense>
  ) : (
    <Navigate to="/login" replace />
  );
};

export default ProtectedRoutes;
